/**
 * Created by guga on 8/19/2016.
 */

export interface IXhrResponse {
    ok         : boolean;
    body       : any;
    status     : number;
    statusText : string;
};

export interface IXhrHeaders {
    [headerKey : string] : string;
};

export interface IXhrOptions {
    [optionKey : string] : any;
};

export interface IXhrRequestPayload {
    path    : string;
    headers : IXhrHeaders;
    options : IXhrOptions;
    data   ?: any;
    method  : string;
    isJson  : boolean;
};

export function createXhrRequestPayload(method : string, path : string, isJson : boolean, data ?: any, headers ?: IXhrHeaders, options ?: IXhrOptions) : IXhrRequestPayload {
    return {
        path,
        headers,
        options,
        data,
        method : method.toUpperCase(),
        isJson
    };
}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas-models/xhr-types.ts